import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'components/Icon'

import {
  Wrapper,
  Container,
  Title,
  Description,
  Disclaimer,
  LogosContainer,
  Logo,
} from './styles'

export const BReligion = ({ texts }) => {
  const { title, description, disclaimer, logos } = texts

  return (
    <Wrapper>
      <Container>
        <Title
          size={['50/60', '50/60', '25/30']}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <Description
          size={['22/30', '22/30', '16/25']}
          dangerouslySetInnerHTML={{ __html: description }}
        />

        <LogosContainer>
          {logos.map(icon => (
            <Logo key={icon}>
              <Icon
                id={icon}
              />
            </Logo>
          ))}
        </LogosContainer>

        <Disclaimer
          size={['16/20', '16/20', '14/20']}
          dangerouslySetInnerHTML={{ __html: disclaimer }}
        />
      </Container>
    </Wrapper>
  )
}

BReligion.propTypes = {
  texts: PropTypes.object.isRequired,
}
